import { Text } from "@mantine/core"

type Props = {
  value?: number
}

export const ScientificNumberCell = ({ value }: Props) => {
  if (!value) return <div>-</div>

  const absValue = Math.abs(value)
  const formattedValue =
    absValue > 1 && absValue < 1000 ? value.toFixed(2) : value.toExponential(2)
  return <Text style={{ whiteSpace: "nowrap" }}>{formattedValue}</Text>
}
